
import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
import { AuthenticationService } from '../_services/index';
import { Router } from '@angular/router';
import { FeatureHelperService } from '../_helpers/feature-helper/feature-helper.service';
import { ThemeService } from '../_helpers/theming-engine/theme.service';

@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html',
    standalone: false
})

export class HomeComponent implements OnInit {
  currentUser: User;
  constructor(
    private themeService: ThemeService,
    private router: Router,
    private authService: AuthenticationService,
    private featureHelperService: FeatureHelperService
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.setAccessRights();
    }, 200);
  }

  setAccessRights() {

    let featureList = new Array<string>();
    featureList.push(
      "TutorHomeView",
      "CoordinatorHomeView",
      "ClientHomeView",
      "Student");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (currentUserFeatures.filter(f => f.feature === "CoordinatorHomeView")[0].enabled) {
      this.router.navigate(['/coordinatorlanding']);
    }
    else if (currentUserFeatures.filter(f => f.feature === "TutorHomeView")[0].enabled) {
      this.router.navigate(['/tutorlanding']);
    }
    else if (currentUserFeatures.filter(f => f.feature === "ClientHomeView")[0].enabled) {
      this.router.navigate(['/clientlanding']);
    }
    else if (currentUserFeatures.filter(f => f.feature === "Student")[0].enabled) {
      this.router.navigate(['/student-home']);
    }
  }
}
